import React, { useState,useEffect, } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import "react-datepicker/dist/react-datepicker.css";  
import CommonAPI from '../Common/CommonAPI';
import CommonAPI2 from '../Common/FD_BILL_APIs';
import FadeLoader from "react-spinners/HashLoader"; 
import Header from '../Common/Header';
import Table from 'react-bootstrap/Table';
import {connect,useSelector,useDispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import {postAction} from '../Middleware/action/postAction';
import {fetchPosts} from '../Middleware/action/postAction';

function Pawning (props) {

    const [SuccessLoading,setSuccessLoading] = useState(true);
    const [TicketList,setTicketList] = useState([]);
    const [ TicketNo,setTicketNo] = useState("");
    const [ PawnDate,setPawnDate] = useState();    
    const [ TotaladvanceAmount,setTotaladvanceAmount] = useState(0);
    const [ PawnItemDetails,setPawnItemDetails] = useState([]);
    const [ CreateAt,setCreateAt] = useState("");
    const [ MobileNo,setMobileNo] = useState("");
    const [ NicOfClient,setNicOfClient] = useState("");
    const [ PhoneNo,setPhoneNo] = useState("");
    const [ Address,setAddress] = useState("");
    const [ AdvanceAmount,setAdvanceAmount] = useState("");
    const [ RatePerMonth,setRatePerMonth] = useState("");
    const [ InterestForDate,setInterestForDate] = useState("");
    const [ TotalOutstanding,setTotalOutstanding] = useState("");
    const [ DueDays,setDueDays] = useState("");
    const [ TotalAssessedValue,setTotalAssessedValue] = useState("");
    const [ CapitalOutstanding,setCapitalOutstanding] = useState("");
    const [ HolderName ,setHolderName] = useState("");

    const amount175 = useSelector((state)=>state.allpost);

    const dispatch1 = useDispatch();    
      
    useEffect( () => {
        GetPawningTicketAPI(); 
        console.log("props val :"+amount175);       
     },[]);

    const GetPawningTicketAPI = () =>{
        CommonAPI2.GetPawnignTicket((result) =>{   
            if(result){                    
                setTicketList(result);
                setTicketNo(result.ticketNo);
                setPawnDate(result.pawnDate);
                setTotaladvanceAmount(result.advanceAmount);
                setSuccessLoading(false);
            } 
            if(result.message){
                console.log("Invalid Request!");
                setSuccessLoading(false);
            }          
        });
    }

const GetTicketDetailsAPI = () =>{
    
    if(TicketNo==="select"||!TicketNo){
        setPawnItemDetails([]);
        setCreateAt('');
        setPawnDate('');
        setMobileNo('');
        setHolderName('')
        setNicOfClient('')
        setPhoneNo ('')
        setAddress('')
        setAdvanceAmount('')
        setRatePerMonth('')
        setInterestForDate('')  
        setTotalOutstanding('')
        setDueDays('')
        setTotalAssessedValue('')
        setCapitalOutstanding('')                 
        setSuccessLoading(false);
      }
   
    if(TicketNo>0){
 CommonAPI2.GetPawnignItems({ticketnumber:TicketNo},(result) =>{   
    if(result){                    
        setPawnItemDetails(result.pawnItemDetails);
        setCreateAt(result.createAt);
        setPawnDate(result.pawnDate);
        setMobileNo(result.mobileNo);
        setHolderName(result.holderName);
        setNicOfClient(result.nicOfClient);
        setPhoneNo (result.phoneNo);
        setAddress(result.address);
        setAdvanceAmount(result.advanceAmount);
        setRatePerMonth(result.ratePerMonth);
        setInterestForDate(result.interestForDate);       
        setTotalOutstanding(result.totalOutstanding);
        setDueDays(result.dueDays);
        setTotalAssessedValue(result.totalAssessedValue);
        setCapitalOutstanding(result.capitalOutstanding);                  
        setSuccessLoading(false);
    } 
    if(result.message){
        console.log("Invalid Request!");
        setSuccessLoading(false);
    }          
    });
    }
}
    const ResponseLoadingModal = () => {
       return(
           <Modal
           size="lg"
           centered 
           className="loading1" show={SuccessLoading}>          
                 <FadeLoader
                 height={25}
                 width={5}
                 radius={2}
                 margin={2}
                 color={"#197b55"}
                 size={"80px"} this also works
                 loading={SuccessLoading}
               />       
          </Modal>
        )
     }
   const SelectTicket =(event) =>{
        setTicketNo(event.target.value);
        
    }

    var arrypaw  = TicketList.map(( listValue, index ) => {return (listValue.advanceAmount+listValue.interest)})
    var Totalpawning = arrypaw.reduce((acc,val)=>{
                                  return acc+val;
                                },0)
    var arry4  = TicketList.map(( listValue, index ) => {return (listValue.advanceAmount)})   
    var TotaladvanceAmountVal = arry4.reduce((acc,val)=>{
                              return acc+val;
                            },0)

    var arry  = PawnItemDetails?PawnItemDetails.map(( listValue, index ) => {return (listValue.weightOfArtical)}):null
    var TotalWeightOfArticle = arry.reduce((acc,val)=>{
                                   return acc+val;
                                 },0)

    var arry2  =PawnItemDetails.map(( listValue, index ) => {return (listValue.netWeightOfArtical)})
    var NetWeightOfArticleTotal = arry2.reduce((acc,val)=>{
                                   return acc+val;
                                 },0)

    var arry3  = PawnItemDetails.map(( listValue, index ) => {return (listValue.netGoldValue)})
    var NetGoldValueTotal = arry3.reduce((acc,val)=>{
                                   return acc+val;
                                 },0)

    if(SuccessLoading){
    return ( <div>{ResponseLoadingModal()}</div> );
    }
   
    return (
        <div>
           
        {/* <Header  />  */}
        <Container >
        
        <Form  className="block mt-4">     
            <Row>
                <Col sm={5} xs={12}>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font t-left" column sm={4}>
                            TICKET NUMBER 
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Select 
                                size="sm"                         
                                className="form-h2 " 
                                onChange={SelectTicket}                           
                                >
                                <option value="select">- SELECT -</option> 
                                {TicketList.map(( listValue, index ) => {
                                    return (
                                        <option  className='pawn-select2'>{listValue.ticketNo}</option>
                                    );
                                })}
                                                                
                            </Form.Select>
                        </Col>
                    </Form.Group>    
                </Col> 
                <Col sm={2} xs={12}>
                    <Form.Group as={Row} className="mb-1">
                        <Col sm={12} xs={12} className="d-flex justify-content-end">
                            <Button 
                            //onClick={()=>dispatch1(fetchPosts())}  
                            onClick={()=>GetTicketDetailsAPI()}
                            className='btn-logout s-top2' variant="primary" type="submit">
                                Go To Ticket
                            </Button>
                        </Col>
                    </Form.Group>
                </Col>
            </Row>                  
            {/* <Form.Group as={Row} className="mb-1">
                <Form.Label className="c-font t-center" column sm={2}>
                    TICKET NUMBER 
                </Form.Label>
                <Col sm={3} >
                <Form.Select 
                    size="sm"                         
                    className="form-h2 " 
                    onChange={SelectTicket}                           
                    >
                    <option value="select">- SELECT -</option> 
                    {TicketList.map(( listValue, index ) => {
                        return (
                            <option  className='pawn-select2'>{listValue.ticketNo}</option>
                        );
                    })}
                                                    
                </Form.Select>
                </Col>
                <Col sm={2} className="d-flex justify-content-end">
                <Button 
                //onClick={()=>dispatch1(fetchPosts())}  
                onClick={()=>GetTicketDetailsAPI()}
                className='btn-logout' variant="primary" type="submit">
                    Go To Ticket
                </Button>
                </Col>
                
            </Form.Group>                       */}
        </Form>
        <Row  style={{marginLeft:2}} className='div-background block d-flex align-items-start'>                    
            <Col lg={3}>
                <div>
                    <p className='p-line2'>Pawn Ticket Number</p>                           
                    <p className='p-line'>{TicketNo==="select"||!TicketNo?"-":TicketNo}</p>
                </div>
            </Col>
            <Col lg={2} className="pawn-list">
                <div>
                <p className='p-line'>Pawning On</p>
                <p className='p-line2'>{PawnDate?moment(PawnDate).format('DD/MM/YYYY'):'-'}</p>
                <p className='p-line m-top'>Capital Outstanding</p>
                <p className='p-line2'>LKR {(CapitalOutstanding)?(parseFloat(CapitalOutstanding).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")):'-'}</p>
                </div>
            </Col>
            <Col lg={2} className="pawn-list">
                <div>
                    <p className='p-line'>Advance Amount</p>
                    <p className='p-line2 m-top'>LKR {AdvanceAmount?parseFloat(AdvanceAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):'-'}</p>                                           
                </div>
            </Col>
            <Col lg={2} className="pawn-list">
                <div>
                <div>
                    <p className='p-line'>Interest for Days {DueDays}</p>
                    <p className='p-line2 '>LKR {InterestForDate?parseFloat(InterestForDate).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):"0.00"}</p>
                    <p className='p-line m-top'>Total Assessed Value</p>
                    <p className='p-line2'>LKR {TotalAssessedValue?parseFloat(TotalAssessedValue).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):'-'}</p>                                
                </div>
                </div>
            </Col>
            <Col lg={3} className="pawn-list">
                <div>
                <div>
                    <p className='p-line '>Total Outstanding</p>
                    <p className='p-line2 '>LKR {TotalOutstanding?parseFloat(TotalOutstanding).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):"0.00"}</p>                                                      
                </div>
                </div>
            </Col>
        </Row>
                <Table className='block-top' hover responsive>
                    <thead >
                        <tr>
                            <th className='td-width3'>Detail Of Items Pawned</th>
                            <th className='td-width3'>Weight of Article</th>
                            <th className='td-width3'>Net Weight of Article</th>
                            <th className='td-width3'>Karates</th>
                            <th className='td-width3'>Net Gold Value</th>
                        </tr>
                    </thead>
                    <tbody className='p-tbody'>
                        {/* {!amount175?"":amount175.map((valueList,index)=>{  */}
                        {PawnItemDetails.map((valueList, index) => {
                            return (
                                <tr>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top'>{valueList.detailsOfItemPawn}</p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top'>{parseFloat(valueList.weightOfArtical).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top'>{parseFloat(valueList.netWeightOfArtical).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top'>{valueList.karats}</p>
                                    </td>
                                    <td className='td-width3'>
                                        <p className='tb-text m-top'>Rs. {parseFloat(valueList.netGoldValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                    </td>
                                </tr>
                            )
                        })
                        }
                    </tbody>
                </Table>        
            <div >    
                <Table className='block-top' hover responsive>
                    <tbody className='tablebody1 t-bold'>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>Total</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{parseFloat(TotalWeightOfArticle).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{parseFloat(NetWeightOfArticleTotal).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'></p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>Rs. {parseFloat(NetGoldValueTotal).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                        </td>
                    </tbody>
                </Table>
            </div>
        <Row lg={12} className="block">                                
            <Col lg={4} className='rmv-pad' >
            <div className='d-box'>                                
                <p className='t-right fontSize'>
                No of Tickets<br/>
                    <h2>{TicketList.length}</h2>
                    
                </p>                                
            </div>                            
            </Col>
            <Col lg={4} className='rmv-pad2'>
            <div className='d-box d-box1'>                                
                <p className='t-right fontSize'>
                Total Advance Given<br/>
                <h2>{TotaladvanceAmountVal?parseFloat(TotaladvanceAmountVal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0}</h2>
                LKR
                </p>                                
            </div>
            </Col>
            <Col lg={4} className='rmv-pad2'>
            <div className='d-box d-box2'>                                
                <p className='t-right fontSize'>
                Total Outstanding<br/>
                    <h2>{parseFloat(Totalpawning).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h2>
                    LKR
                </p>                                
            </div>                            
            </Col>        
        </Row>        
    </Container>
    </div>
    )  
}

export default Pawning;